import React, { useState, useEffect } from 'react';
import { Alert } from 'reactstrap';
import { useHistory } from "react-router-dom";
import './index.css';
import { login } from "../../services/auth";
import api from '../../services/api_adiantamento';
import aiempresa from '../../services/api_lambda'
import { FaRegEyeSlash } from "react-icons/fa";
import logo from "./icone.png";


export default function Empresas() {
    if(document.getElementById('footer_empresa')) {
        document.getElementById('footer_empresa').innerHTML = '';
    }

    const usuario = {
        usuario: localStorage.getItem('usuario'),
        id: localStorage.getItem('usuario_id'),
    }

    let history = useHistory();

    const [empresa, setEmpresa] = useState({
        items: [],
        selectItem: 1
    });

    useEffect(() => {
        if (usuario.id) {
            api.get(`/usuarios/getemp?usuario_id=${usuario.id}`).then(function (response) {
                if (response.data) {
                    if (response.data.empresas) {
                        var emp = {
                            items: [],
                            selectItem: response.data.empresas[0].id,
                        };
                        response.data.empresas.forEach((empresa, index) => (
                            emp.items.push({ id: empresa.id, text: empresa.descempresa })
                        ))
                        setEmpresa(emp);
                    }
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, []);

    function handleSelectEmpresa(event) {
        const emp = Object.assign([], empresa);
        emp.selectItem = event.target.value;
        setEmpresa(emp);
    }

    function onSubmit() {
        const data = { usuario: usuario.usuario, usuario_id: usuario.id, empresa: empresa.selectItem };
        api.post("/usuarios/acessar", data).then(function (response) {
            if (response.data) {
                if (response.data.erro) {
                    alert(response.data.erro);
                    return;
                } else {
                    if(response.data.token){
                        login(response.data.token, empresa.selectItem);
                        history.push('/home');
                    } else {
                        alert('Ocorreu algum erro!')
                    }
                }
            }
        }).catch((e) => {
            alert(e.message)
        });
    }

    return (
        <div className="login">
            <div className="col-md-4">
                <header className='header-login'>
                    <img className='img-logo' alt="logo" src={logo}></img>
                    <h1 className="text-center font-weight-bold">SELECIONAR EMPRESA</h1>

                </header>
                <div className="mb-2">
                    <select className="col-md-12 form-control" value={empresa.selectItem} onChange={(e) => handleSelectEmpresa(e)}>
                        {empresa.items.map((item, index) => (
                            <option key={item.id} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <input className="btn btn-primary" type="button" value='ENTRAR' onClick={() => onSubmit()} />
                </div>
            </div>
        </div>
    )
}